/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Table from '../../components/layout/Table'
import vanBangBanSaoState from '../../constant/vanBangBanSaoState'
// import truongProcessor from '../../processor/truongProcessor'
import userProcessor from '../../processor/userProcessor'
import vanBangBanSaoProcessor from '../../processor/vanBangBanSaoProcessor'
// import { setTruongs } from '../../store/reducer/truong'
import { setUsers } from '../../store/reducer/user'
import store from '../../store/store'
import { dateToDDMMYY } from '../../utils/date'
import { truncate } from '../../utils/string'
import InVanBangBanSao from './InVanBangBanSao'
import LichSuVanBangBanSao from './LichSuVanBangBanSao'

const VanBangBanSaoDaDuyet = () => {
  const [datas, setDatas] = useState([])
  const [lichSuId, setLichSuId] = useState({})
  const [lichSuVisible, setLichSuVisible] = useState(false)
  const [vanBang, setVanBang] = useState(null)
  const [inVisible, setInVisible] = useState(false)
  const { users } = useSelector((state) => state.user)
  const userDonVi = useSelector((item) => item.user.info.donVi)

  const toggleLichSuVisible = () => setLichSuVisible(!lichSuVisible)
  const toggleInVisible = () => setInVisible(!inVisible)

  const getUsers = async () => {
    const rs = await userProcessor.getAll()
    store.dispatch(setUsers(rs))
  }
  const getDatas = async () => {
    const rs = await vanBangBanSaoProcessor.getByState(vanBangBanSaoState.daDuyet)
    setDatas(rs)
  }
  // const getBaseData = async () => {
  // const truongs = await truongProcessor.getAll()
  // store.dispatch(setTruongs(truongs))
  // }
  useEffect(async () => {
    getDatas()
    getUsers()
    // getBaseData()
  }, [])

  const columnTable = [
    {
      value: 'soHieuBanChinh',
      name: 'Số hiệu cũ',
      render: (item) => item.vanBang && item.vanBang.soHieu,
    },
    { value: 'soHieu', name: 'Số hiệu mới' },
    { value: 'soVaoSo', name: 'Số vào sổ' },
    // { value: 'soBan', name: 'Số bản' },
    { value: 'soBan', name: 'Số bản cấp' },
    {
      value: 'ngayTao',
      name: 'Ngày tạo',
      render: (item) => {
        return dateToDDMMYY(new Date(item.ngayTao))
      },
    },
    {
      value: 'nguoiDuyetId',
      name: 'Người duyệt',
      render: (item) => {
        const user = users.find((u) => u.id === item.nguoiDuyetId)
        return user ? user.fullname : ''
      },
    },
    {
      value: 'fileDinhKem',
      name: 'File đính kèm',
      render: (data) => {
        const files = data.fileDinhKem ? data.fileDinhKem.split(',') : []
        return (
          <div className="flex flex-column">
            {files.map((item) => (
              <a href={`/${item}`} className="mb-2" download>
                {truncate(item, 20)}
              </a>
            ))}
          </div>
        )
      },
    },
    {
      value: 'chinhSuaVanBangs',
      name: 'Thông tin phản hồi',
      render: (data) => {
        return (
          <div>
            {data.phanHoiBanSaos &&
              data.phanHoiBanSaos.map((item) => (
                <p>{`[${dateToDDMMYY(new Date(item.createDate))}] ${item.user.fullname}: ${
                  item.noiDung
                }`}</p>
              ))}
          </div>
        )
      },
    },
    {
      name: 'Chức năng',
      alignHeader: 'center',
      render: (data) => {
        return (
          <div className="flex justify-content-center ">
            <Button
              icon="pi pi-history"
              className="p-button-rounded p-button-warning mr-2"
              tooltip="Lịch sử cấp phát"
              tooltipOptions={{ position: 'top' }}
              onClick={() => {
                setLichSuId({ id: data.vanBangId })
                toggleLichSuVisible()
              }}
            />
            <Button
              icon="pi pi-print"
              className="p-button-rounded"
              tooltip="In"
              tooltipOptions={{ position: 'top' }}
              onClick={() => {
                setVanBang({ ...data })
                toggleInVisible()
              }}
            />
          </div>
        )
      },
    },
  ]

  return (
    <>
      <LichSuVanBangBanSao data={lichSuId} visible={lichSuVisible} toggle={toggleLichSuVisible} />
      <InVanBangBanSao
        data={vanBang}
        visible={inVisible}
        toggle={toggleInVisible}
        donVi={userDonVi}
      />
      <h4>Danh sách văn bằng bản sao đã duyệt</h4>
      <div className="card">
        <Table data={datas} column={columnTable} />
      </div>
    </>
  )
}
export default VanBangBanSaoDaDuyet
